import script from "./CurrentListings.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentListings.vue?vue&type=script&setup=true&lang=js"

import "./CurrentListings.vue?vue&type=style&index=0&id=325fa3c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-325fa3c5"]])

export default __exports__